import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import * as SharedActions from './shared.actions';
import { SharedEntity } from './shared.models';
import { Helper } from '../../../../../shared/src/lib/service/helper.service';

export const SHARED_FEATURE_KEY = 'shared';

export interface SharedState extends EntityState<SharedEntity> {
  selectedId?: string | number; // which Shared record has been selected
  isLoaded: boolean; // has the Shared list been loaded
  error?: string | null; // last known error (if any)
  countryList: [] | null;
  stateList: [] | null;
  planList: [] | null;
  validateEmail: any;
  isClearSearch: boolean;
  allCityList: [] | any;
  allGridConfig: [] | any;
  gridState: any;
}

export interface SharedPartialState {
  readonly [SHARED_FEATURE_KEY]: SharedState;
}

export const sharedAdapter: EntityAdapter<SharedEntity> = createEntityAdapter<SharedEntity>();

export const initialSharedState: SharedState = sharedAdapter.getInitialState({
  // set initial required properties
  isLoaded: true,
  countryList: [],
  stateList: [],
  planList: [],
  validateEmail: '',
  isClearSearch: false,
  allCityList: [],
  allGridConfig: [],
  gridState: [],
});

const reducer = createReducer(
  initialSharedState,
  //reducer for getCountry.
  on(SharedActions.getCountry, state => {
    return { ...state, error: null };
  }),
  on(SharedActions.getCountrySuccess, (state, { countryList }) => {
    return { ...state, countryList: countryList };
  }),
  on(SharedActions.getCountryFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  //reducer for getStates.
  on(SharedActions.getStates, state => {
    return { ...state, error: null };
  }),
  on(SharedActions.getStatesSuccess, (state, { stateList }) => {
    const updatedStateData = stateList.map((item: any) => {
      return {
        ...item,
        name: Helper.convertToTitleCaseforState(item.name),
      };
    });

    return { ...state, stateList: updatedStateData };
  }),

  on(SharedActions.getStatesFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  //reducer for getPlan.
  on(SharedActions.getPlan, (state, payload) => {
    return {
      ...state,
      payload: payload,
      loading: true, // Add loading state
      error: null,
      planList: [], // Clear previous plans when starting new request
    };
  }),
  on(SharedActions.getPlanSuccess, (state, { planList }) => {
    return {
      ...state,
      planList: planList || [],
      loading: false,
      error: null,
    };
  }),
  on(SharedActions.getPlanFailure, (state, { error }) => ({
    ...state,
    planList: [],
    loading: false,
    error,
  })),
  on(SharedActions.setPlanListFromCache, (state, { planList }) => ({
    ...state,
    planList: planList || [],
    loading: false,
    error: null,
  })),
  on(SharedActions.clearPlanList, state => ({
    ...state,
    planList: [],
    loading: false,
    error: null,
  })),
  //reducer for isEmailExist.
  on(SharedActions.isEmailExist, (state, payload) => {
    return { ...state, payload: payload, error: null };
  }),
  on(SharedActions.isEmailExistSuccess, (state, { validateEmail }) => {
    return { ...state, validateEmail: validateEmail };
  }),
  on(SharedActions.isEmailExistFailure, (state, { error }) => ({ ...state, error })),
  //reducer for clearEmailVal.
  on(SharedActions.clearEmailVal, state => {
    return { ...state, validateEmail: [] };
  }),

  // on(SharedActions.hideShowLoader, (state, { isLoaded }) => ({ ...state, isLoaded: isLoaded })),
  on(SharedActions.clearSearchFilter, (state, { isClearSearch }) => ({
    ...state,
    isClearSearch: isClearSearch,
  })),

  on(SharedActions.getAllGridConfigSuccess, (state, allGridConfig) => {
    return { ...state, ...allGridConfig, loaded: false };
  }),
  on(SharedActions.setGridCofiguration, (state, gridState) => {
    return { ...state, ...gridState };
  }),
  on(SharedActions.updateGridCofiguration, (state, gridState) => {
    return { ...state, ...gridState };
  })
);

export function sharedReducer(state: SharedState | undefined, action: Action) {
  return reducer(state, action);
}
